import { motion } from "framer-motion";
import { Flame, Zap, Crown, Rocket, Lock } from "lucide-react";

export const BADGE_TIERS = [
  { n: 3, name: "Hot Hand", icon: Flame, color: "text-orange-400", ring: "border-orange-400/50 bg-orange-400/10" },
  { n: 5, name: "On Fire", icon: Zap, color: "text-yellow-300", ring: "border-yellow-300/50 bg-yellow-300/10" },
  { n: 10, name: "Unstoppable", icon: Rocket, color: "text-sky-400", ring: "border-sky-400/50 bg-sky-400/10" },
  { n: 20, name: "Legend", icon: Crown, color: "text-pazer-red", ring: "border-pazer-red/60 bg-pazer-red/10" },
];

export function StreakBadges({ current, best }) {
  const next = BADGE_TIERS.find((t) => best < t.n);
  return (
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15 }}
      className="rounded-2xl pz-glass p-6 mb-4" data-testid="streak-badges">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-display font-bold text-lg">Win Streak Badges</h3>
        <div className="flex gap-4 text-right">
          <div><div className="font-mono-pz font-bold text-xl text-orange-400" data-testid="current-win-streak">{current}</div><div className="text-[10px] text-white/40 uppercase">Current</div></div>
          <div><div className="font-mono-pz font-bold text-xl text-green-400" data-testid="best-win-streak">{best}</div><div className="text-[10px] text-white/40 uppercase">Best</div></div>
        </div>
      </div>
      <div className="grid grid-cols-4 gap-2">
        {BADGE_TIERS.map((t, i) => {
          const got = best >= t.n;
          return (
            <motion.div key={t.n} initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ delay: 0.2 + i * 0.06 }}
              data-testid={`badge-${t.n}`} data-unlocked={got}
              className={`rounded-xl border p-3 text-center ${got ? t.ring : "border-white/10 bg-black/30 opacity-50"}`}>
              {got ? <t.icon className={`h-7 w-7 mx-auto mb-1 ${t.color}`} /> : <Lock className="h-7 w-7 mx-auto mb-1 text-white/30" />}
              <div className="text-[11px] font-bold leading-tight">{t.name}</div>
              <div className="text-[10px] text-white/40 font-mono-pz">{t.n} wins</div>
            </motion.div>
          );
        })}
      </div>
      <p className="text-xs text-white/50 mt-3" data-testid="next-badge-hint">
        {next ? `Win ${next.n - current} more in a row to unlock ${next.name}${current < best ? " (beat your best!)" : ""}.` : "All badges unlocked. You're a legend!"}
      </p>
    </motion.div>
  );
}
